var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconQuoteIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1839_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.5 235.864L431.03 122.071C431.03 105.181 421.457 89.7136 406.344 82.1678C391.253 74.6638 373.13 76.336 359.606 86.4737L161.326 235.864C147.175 241.967 137.978 249.868 132.041 257.978L17.7466 344.076C6.52201 352.541 -0.0622635 365.814 0.000443895 379.861C0.0422488 393.928 6.73104 407.138 18.0184 415.52L359.878 669.13C373.381 679.163 391.441 680.71 406.491 673.122C421.54 665.556 431.03 650.13 431.03 633.303L414.5 500.5C397.176 483.016 414.772 500.5 414.5 500.5C494.807 500.5 655.209 540.747 711.207 693.272C717.707 710.956 734.534 722.473 753.033 722.473C754.684 722.473 756.314 722.389 757.966 722.201C778.345 719.944 794.566 704.058 797.262 683.741C798.349 675.505 822.512 481.363 704.016 344.494C640.055 270.645 531.846 245.291 414.5 235.864ZM431.824 428.814C401.662 428.814 382.097 431.573 379.944 431.866C358.081 435.085 341.86 453.876 341.86 475.991L341.86 569L73 379.861L341.86 195.5C339.645 198.196 344.703 193.326 341.86 195.5C339.018 197.632 345.1 194.079 341.86 195.5L341.86 211.512V261.699C341.86 286.113 361.488 305.991 385.923 306.305C497.646 307.622 603.633 331.002 658 393.5C688.141 428.156 743.5 548 743.5 605C646.5 475.991 489.62 428.814 431.824 428.814Z",
    fill: "#808080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1839_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuoteIndicator);
export default __webpack_public_path__ + "static/media/icon-quote-indicator.1ed2df5e37a485992d75528ff661bd6a.svg";
export { ForwardRef as ReactComponent };